/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/CallCenterBookingOptions.js
 * vim:ft=javascript.jsx:
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';

import SendVoucher from './SendVoucher';
import SendPaymentUpfrontLink from './SendPaymentUpfrontLink';

class CallCenterBookingOptions extends React.Component {
  render() {
    return (
      <div className="CallCenterBooking mt-4" style={{ marginLeft: '20px' }}>
        <SendVoucher locator={this.props.locator} lang={this.props.lang} />
        <SendPaymentUpfrontLink booking={this.props.booking} />
      </div>
    );
  }
}

CallCenterBookingOptions.propTypes = {
  booking: PropTypes.object,
  locator: PropTypes.string,
  lang: PropTypes.string,
};

export default CallCenterBookingOptions;
